import type { PriceWarningList } from './price-warning-list';
import type { Warning } from './warning';

export enum WarningKindEnum {
    Info = 0, 
    Error = 1
}

export enum WarningKeyEnum {
    QTY_NEEDED = "qty_needed",
    LIMIT_REACHED = "limit_reached",
    PROMO_LIMIT_REACHED = "promo_limit_reached",
    QTY_TO_REMOVE = "qty_to_remove",
    MISSING_QTY = "missing_qty",
    MISSING_QTY_ACCESS_SALE = "missing_qty_access_sale",
    MAXIMUM_QTY = "maximum_qty",
    MULTIPLE_OF_NEEDED = "multiple_of_needed",
    MULTIPLE_OF_NEEDED_ACCESS_SALE = "multiple_of_needed_access_sale",
    REQUIRED_CREDIT_CARD = "required_credit_card",
    REQUIRED_MEMBERSHIP_CARD = "required_membership_card",
    HAVE_EXPIRED_TICKETS = "have_expired_tickets",
    HAVE_ALREADY_TICKETS_IN_CART = "have_already_tickets_in_cart",
    SELECTION_LEAVES_HOLES_IN_VENUE = "selection_leaves_holes_in_venue",
}

export type TicketSelectionWarningReport = {
    //eventDateId: number;
    //expiredTicketsWarning?: Warning;
    generalWarnings?: Warning[];
    
    priceListWarnings?: PriceWarningList[];
}